import { z } from 'zod';

export const fileSchema = z.object({
  id: z.string(),
  appId: z.string(),
  path: z.string(),
  filename: z.string(),
  contentType: z.string(),
  size: z.string().nullable(),
  visibility: z.enum(['PUBLIC', 'PRIVATE']),
  status: z.enum(['PENDING', 'UPLOADED', 'DELETED']),
  processing: z.enum(['NONE', 'QUEUED', 'DONE', 'FAILED']),
  processingError: z.string().nullable(),
  processingQueuedAt: z.string().nullable().optional(),
  processingStartedAt: z.string().nullable().optional(),
  processingFinishedAt: z.string().nullable().optional(),
  sha256: z.string().nullable().optional(),
  sha256Source: z.enum(['client', 'worker']).nullable().optional(),
  image: z
    .object({
      width: z.number(),
      height: z.number(),
      orientation: z.number().nullable(),
      takenAt: z.string().nullable(),
      takenAtLocal: z.string().nullable().optional(),
      takenAtOffset: z.string().nullable().optional(),
      camera: z
        .object({
          make: z.string().nullable(),
          model: z.string().nullable(),
          lens: z.string().nullable(),
        })
        .nullable(),
      gps: z.object({ latitude: z.number(), longitude: z.number() }).nullable().optional(),
    })
    .nullable()
    .optional(),
  ownerId: z.string().nullable(),
  tenantId: z.string().nullable(),
  url: z.string().nullable(),
  variants: z.array(
    z.object({
      name: z.string(),
      url: z.string().nullable(),
      contentType: z.string(),
      width: z.number(),
      height: z.number(),
      size: z.string(),
    }),
  ),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type FistoFile = z.infer<typeof fileSchema>;
export type FistoVariant = FistoFile['variants'][number];

export const downloadUrlSchema = z.object({ url: z.string(), expiresAt: z.string().nullable() });
